// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import cvtEntity from './entities/cvt.json';
import cvtMenu from '../pages/cvt/menu.json';
import cvtFullForm from '../pages/cvt/forms/full.json';
import cvtContextForm from '../pages/cvt/forms/context.json';
import cvtMiniForm from '../pages/cvt/forms/mini.json';
import cvtLookupForm from '../pages/cvt/forms/lookup.json';
import cvtTableView from '../pages/cvt/views/table.json';
import cvtStagesView from '../pages/cvt/views/stages.json';
import cvtCardsView from '../pages/cvt/views/cards.json';
import cvtInlineView from '../pages/cvt/views/inline.json';
import cvtBacklogView from '../pages/cvt/views/backlog.json';
import cvtSplitView from '../pages/cvt/views/split.json';
import cvtCalendarView from '../pages/cvt/views/calendar.json';
import cvtDashboardView from '../pages/cvt/views/dashboard.json';

/** Тип запису «Голосування комітету» зі сторінками пакета: меню, форми та подання з pages/cvt/. */
export const cvtDefinition: IRecordTypeDefinition = {
  ...cvtEntity,
  views: assembleViewSet({
      table: cvtTableView,
      stages: cvtStagesView,
      cards: cvtCardsView,
      inline: cvtInlineView,
      backlog: cvtBacklogView,
      split: cvtSplitView,
      calendar: cvtCalendarView,
      dashboard: cvtDashboardView,
  }),
  form: cvtFullForm,
  forms: { full: cvtFullForm, context: cvtContextForm, mini: cvtMiniForm, lookup: cvtLookupForm },
  menu: cvtMenu,
} as IRecordTypeDefinition;
